import { WORKSPACE_GROUP } from '~/issues/constants';
import { initWorkItemsRoot } from '~/work_items';

initWorkItemsRoot({ workspaceType: WORKSPACE_GROUP });
